export default [
    {
        path: '/attributions',
        name: 'attributions',
        component: () => import ('./pages/AttributionRegister')
    },
]